import { take, select } from 'redux-saga/effects'

import Loader from 'common/modules/loader'
import Account from 'common/modules/account'
import Internal from 'common/modules/internal'

import { types as lifecycleTypes, creators } from '../../actions'

export default {
    [lifecycleTypes.USER_REGISTERED]: [
        {
            event: 'pico.user.registered',
            * data() {
                yield take(Loader.types.GET_LOADER_SUCCESS)
                const email = yield select(Loader.selectors.userEmail)
                return {
                    detail: { email },
                }
            },
        },
    ],
}

let newRegisteredUserEventSent = false

export const checkNewPicoUserRegistered = () => ({ state, dispatch }) => {
    const newRegisteredUser = Account.selectors.isNewRegistration(state)
    if (newRegisteredUser && !newRegisteredUserEventSent) {
        newRegisteredUserEventSent = true
        dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...(creators.userRegistered()),
            },
        }))
    }
}
